module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/cup/4-c308f54d366cde5d6fbbcb0463745a85.jpg";